import React from "react";
import "./App.css";
import axios from "axios";
import { useEffect, useState } from "react";
import { LoginButton } from "./components/login-button";
import { LoginLoader } from "./components/login-loader";
const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;

function App({ sign, personalNumber }) {
  const [response, setResponse] = useState();
  const [redirect, setRedirect] = useState(false);
  const [grandidsession, setGrandidsession] = useState();
  const [loading, setLoading] = useState(false);

  const isLocalDev = process.env.NODE_ENV === "development";
  // callback Url for redirection after bankId signing
  const currentUrl = window.location.href;
  const callbackUrl = isLocalDev ? "http://localhost:3000" : currentUrl; // Replace this for production url

  function setCookie(cookieName, cookieValue, expirationDays) {
    let d = new Date();
    d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie =
      cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  }

  const getCookie = async (name) => {
    let cookieValue;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  };

  // useEffect to detect redirects from Svensk e-identitet, to initiate get session
  useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    const grandidsessionParam = params.get("grandidsession");
    if (grandidsessionParam) {
      setGrandidsession(grandidsessionParam);
    }
  }, []);

  const sessionIdentifierString = "baidUserInfo";

  const fetch = async (url, options) => {
    const defaultOptions = {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const fetchOptions = { ...defaultOptions, ...options };
    // console.log("fetchOptions: ", fetchOptions);
    try {
      const response = await axios(url, fetchOptions);
      setResponse(response);
    } catch (error) {
      console.error(error);
    }
  };

  const runFetchSession = async () => {
    window.history.replaceState(null, "", window.location.href.split("?")[0]);
    if (sign) {
      const userInfoCookie = await getCookie("baidUserInfo");
      return fetch(
        `${apiBaseUrl}/confirm-subscription/?grandidsession=${grandidsession}`,
        { data: userInfoCookie, method: "post" }
      );
    } else {
      return fetch(
        `${apiBaseUrl}/get-session/?grandidsession=${grandidsession}`
      );
    }
  };

  //Handle bank id login initiation
  const initiateBankId = async (sign) => {
    setRedirect(true);
    if (sign) {
      let url = `${apiBaseUrl}/sign-subscribe?callbackurl=${callbackUrl}`;
      // personalNumber && (url = `${url}?pn=${personalNumber}`);
      return fetch(url, {
        method: "post",
        data: { personalNumber: personalNumber },
      });
    } else {
      //with callback url
      return fetch(`${apiBaseUrl}/login?callbackurl=${callbackUrl}`);
    }
  };

  useEffect(() => {
    if (response?.data?.redirectUrl && redirect) {
      setRedirect(false);
      const redirectUrl = response.data.redirectUrl;
      setResponse();
      window.location.assign(redirectUrl);
    }
    if (response?.data?.encryptedCookie) {
      const data = response.data.encryptedCookie;
      const sessionLength = response.data.sessionLengthDays || 2;
      setCookie(sessionIdentifierString, JSON.stringify(data), sessionLength);
      //Rerender or redirect to read in user cookie data to wordpress backend

      //Since you are not supposed to reach "mina-sidor" when logged in with bankid, relocate to "/" else reload
      window.location.pathname === "/mina-sidor/" && !response.data.error
        ? (window.location.href = "/")
        : window.location.reload();
    }
  }, [response, redirect]);

  useEffect(() => {
    if (grandidsession) {
      setLoading(true);
      runFetchSession();
    }
  }, [grandidsession]);

  return (
    <>
      {!loading && (
        <LoginButton sign={sign} onClick={() => initiateBankId(sign)} />
      )}
      {loading && <LoginLoader />}
    </>
  );
}

export default App;
